import CardHoverInfo from '../CardHoverInfo';
import TarotCard from '../TarotCard';
import './RelationshipSpread.css';

/** The relationship layout: the dealt cards in their positions. */
function RelationshipSpread({ spread, cards, revealed, onReveal }) {
  return (
    <div className="relationship-layout">
      {cards.map((card, index) => {
        const position = spread.positions[index];
        const isRevealed = revealed.includes(index);

        return (
          <div
            key={index}
            className={`card-position position-${index + 1} ${isRevealed ? 'revealed' : ''}`}
            onClick={() => onReveal(index)}
          >
            <div className="position-label">
              <span className="position-number">{position.id}</span>
              <span className="position-name">{position.name}</span>
            </div>
            <CardHoverInfo card={card}>
              <TarotCard card={card} isRevealed={isRevealed} />
            </CardHoverInfo>
            <div className="position-description">
              {position.description}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default RelationshipSpread;
